import {
  IonBackButton, IonButtons, IonCol,
  IonContent,
  IonGrid,
  IonHeader, IonItemDivider,
  IonLabel, IonPage,
  IonRow, IonTitle, IonToolbar,
  useIonViewWillEnter
} from "@ionic/react";
import React from "react";
import { useDispatch } from "react-redux";
import { resetDocumentList } from "../../store/documentList";
import { fetchDocuments } from "../../store/documentList/actions/fetchDocuments";
import { CreateDocumentButton } from "./components/CreateDocumentButton";
import { DocumentCount } from "./components/DocumentCount";
import { DocumentsListSection } from "./components/DocumentsListSection";
import { FilterCreatedAtSelector } from "./components/FilterCreatedAtSelector";
import { FilterSection } from "./components/FilterSection";
import { FilterStatusSelector } from "./components/FilterStatusSelector";
import { FilterTypeSelector } from "./components/FilterTypeSelector";
import { HelperActions } from "./components/HelperActions";
import { SearchTextInput } from "./components/SearchTextInput";
import { SortSelector } from "./components/SortSelector";
import { ViewModeSelector } from "./components/ViewModeSelector";

export const DocumentList: React.FC = () => {
  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(resetDocumentList());
    dispatch(fetchDocuments());
  });

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/rrhh" />
          </IonButtons>
          <IonTitle>Acuerdos</IonTitle>
          <IonButtons slot="end">
            <HelperActions />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol size="12" sizeMd="8" sizeLg="6">
              <SearchTextInput />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="ion-padding-horizontal">
          <IonRow class="ion-align-items-center">
            <IonCol size="auto" style={{ display: "flex" }}>
              <FilterSection />
            </IonCol>
          </IonRow>
        </IonGrid>

        <section className="ion-padding-horizontal">
          <IonItemDivider class="ion-margin-bottom">
            <IonLabel>
              <h2>
                <DocumentCount />
              </h2>
            </IonLabel>
            <IonButtons slot="end">
              <SortSelector />
              <ViewModeSelector />
            </IonButtons>
          </IonItemDivider>
        </section>

        <DocumentsListSection />

        <CreateDocumentButton />
        <FilterTypeSelector />
        <FilterStatusSelector />
        <FilterCreatedAtSelector />
      </IonContent>
    </IonPage>
  );
};
